import React, { useState } from 'react';
import { Container, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { testimonialsData } from '../../data/Data';
import { Box, MainHeading, TextStyled } from '../../Styled/Elements';
import { SliderOuter, TestimonialsWrapper } from './Styled';
import TestimonialLightbox from './TestimonialLightbox';
import TestimonialsGrid from './TestimonialsGrid';
import TestimonialsSlider from './TestimonialsSlider';
import { USE_TESTIMONIALS_SLIDER } from './testimonialsConfig';

const Testimonials = () => {
    const { t } = useTranslation();
    const [activeIndex, setActiveIndex] = useState(null);

    const openLightbox = (index) => setActiveIndex(index);
    const closeLightbox = () => setActiveIndex(null);

    const navigate = (direction) => {
        setActiveIndex((prev) => {
            const next = prev + direction;
            if (next < 0) return testimonialsData.length - 1;
            if (next >= testimonialsData.length) return 0;
            return next;
        });
    };

    return (
        <>
            <TestimonialsWrapper className="common-space">
                <Container>
                    <Row className="common-space">
                        <Box className="heading-content">
                            <MainHeading className="main-heading themeColor" transform="capitalize">
                                {t('Testimonials_heading')}
                            </MainHeading>
                            <TextStyled size="18px" color="var(--lightBlue)">
                                {t('Testimonials_subheading')}
                            </TextStyled>
                        </Box>
                    </Row>
                    {!USE_TESTIMONIALS_SLIDER && (
                        <TestimonialsGrid onOpenLightbox={openLightbox} />
                    )}
                </Container>
                {USE_TESTIMONIALS_SLIDER && (
                    <SliderOuter className="testimonials-slider-outer">
                        <TestimonialsSlider onOpenLightbox={openLightbox} />
                    </SliderOuter>
                )}
            </TestimonialsWrapper>

            <TestimonialLightbox
                images={testimonialsData}
                activeIndex={activeIndex}
                onClose={closeLightbox}
                onNavigate={navigate}
            />
        </>
    );
};

export default Testimonials;
